module.exports = __webpack_public_path__ + "img/transaction_green.8d94281d.svg";